import Card from "@rio-cloud/rio-uikit/Card";

interface PanelShellProps {
  loading: boolean;
  loadingLabel: string;
  hasData: boolean;
  className?: string;
  children: React.ReactNode;
}

interface PanelLoaderProps {
  label: string;
}

const PanelLoader = ({ label }: PanelLoaderProps) => (
  <Card className="padding-30 display-flex justify-content-center align-items-center gap-10 min-height-150">
    <span className="rioglyph rioglyph-refresh spinning text-size-20 text-color-primary" />
    <span className="text-size-16 text-bold text-color-dark">Carregando {label}...</span>
  </Card>
);

const PanelEmptyState = ({ label }: PanelLoaderProps) => {
  return (
    <Card className="padding-30 display-flex flex-column justify-content-center align-items-center gap-10 min-height-150">
      <span className="rioglyph rioglyph-info-sign text-size-28 text-color-primary" aria-hidden="true" />
      <span className="text-size-14 text-color-dark text-center">Ainda não há dados carregados para {label}</span>
    </Card>
  );
};

export default function PanelShell({ loading, loadingLabel, hasData, className = "", children }: PanelShellProps) {
  if (loading) {
    return (
      <div className={className}>
        <PanelLoader label={loadingLabel} />
      </div>
    );
  }

  if (!hasData) {
    return (
      <div className={className}>
        <PanelEmptyState label={loadingLabel} />
      </div>
    );
  }

  return <div className={className}>{children}</div>;
}
